export class BewegingZonderRitModel {
  constructor(
    public treinnummer: number,
    public treindatum: string,
    public dienstregelVersie: number,
  ) {}
}

export function mapBewegingZonderRit(rawModel: BewegingZonderRitModel): BewegingZonderRitModel {
  return new BewegingZonderRitModel(rawModel.treinnummer, rawModel.treindatum, rawModel.dienstregelVersie);
}

export function mapArrayOfBewegingZonderRit(rawArray: BewegingZonderRitModel[]): BewegingZonderRitModel[] {
  return rawArray.map(mapBewegingZonderRit);
}
